import { FC } from 'react';
import { observer } from 'mobx-react';
import AppLayout from "modules/clients/containers/Single/components/Layout";
import clientStore from 'stores/client';
import Files from 'submodules/files/containers/index';


const ClientFiles: FC = observer(() => {
  const client: any = clientStore.selected;

  return (
    <AppLayout>
      <Files resource_type='Client' resource={client} />
    </AppLayout>
  );
})

export default ClientFiles;
